var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconRetryArtwork = function SvgIconRetryArtwork(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M9.5 4.398a9.3 9.3 0 0 0-2.675.399.75.75 0 1 1-.43-1.437c.93-.278 1.963-.462 3.105-.462a9.42 9.42 0 0 1 9.42 9.42 9.42 9.42 0 0 1-9.42 9.42 9.42 9.42 0 0 1-9.42-9.42 9.4 9.4 0 0 1 1.586-5.236.75.75 0 0 1 1.248.832 7.9 7.9 0 0 0-1.334 4.404 7.92 7.92 0 0 0 7.92 7.92 7.92 7.92 0 0 0 7.92-7.92 7.92 7.92 0 0 0-7.92-7.92",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M8.753.434a.75.75 0 0 1 .073 1.058l-2.89 3.32a.75.75 0 0 1-1.132-.984l2.89-3.32A.75.75 0 0 1 8.753.434",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#181818",
    fillRule: "evenodd",
    d: "M4.764 3.878a.75.75 0 0 1 1.048-.163l3.37 2.46a.75.75 0 0 1-.884 1.211l-3.37-2.46a.75.75 0 0 1-.164-1.048",
    clipRule: "evenodd"
  })));
};
export default SvgIconRetryArtwork;